<shared-locations-for-intro></shared-locations-for-intro>